import React from 'react';
import {BrowserRouter as Router,Route} from 'react-router-dom';


import { Main } from './components/main'

import './styles/header.css'



class App extends React.Component {

    constructor(props){
      super(props);
    }

    componentDidMount() {
    }

  render() {
    return (
    <div id="b">
        <ul id="h" className="menu-list">
            <li className="selected"><a href="/">ReleaseNote Central</a></li>
            <li ><a href="/applications">Applications</a></li>
        </ul>
      <Router>
          <div>
            <Route exact path="/" component={Main} />
            <Route path="/applications">
              <Main />
            </Route>
          </div>
      </Router>
    </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js